const BankAccountPriority = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
};

export default BankAccountPriority;
